export default __webpack_public_path__ + "static/media/valoop.13916d37.svg";